import { render, staticRenderFns } from "./UserSectionInfo.vue?vue&type=template&id=0b97e083&"
import script from "./UserSectionInfo.vue?vue&type=script&lang=js&"
export * from "./UserSectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSectionInfo.vue"
export default component.exports